<template>
  <qx-card-form :title="title">

    <qx-custom-form
      :noSubBtn="true"
      ref="baseForm"
      :formData="baseForm"
      labelWidth="160px"
      v-if="baseForm.form.length !== 0"
    >
      <section slot="order2" slot-scope="prop" class="choose-flex">
          <ChooseWorker ref="chooseWorker" @change="handleUserOrder2Change" :customShow="true"/>
          <div style="width:290px; position:relative">
            <span style="width:240px;height:200px;border:1px solid #DCDFE6; display: block;word-break:break-all">{{selectedWorkers}}</span>
            <el-link type="primary" @click="showUserDialog" style="position:absolute;right: 0;top:0" :underline="false">选择</el-link>
          </div>
      </section>
      <section slot="order4" slot-scope="prop" class="choose-flex">
          <ChooseWorker ref="chooseWorker" @change="handleUserOrder4Change" :customShow="true" v-model="prop.form.order4"/>
          <div style="width:290px; position:relative">
            <span style="width:240px;height:200px;border:1px solid #DCDFE6; display: block;word-break:break-all">{{selectedWorkers}}</span>
            <el-link type="primary" @click="showUserDialog" style="position:absolute;right: 0;top:0" :underline="false">选择</el-link>
          </div>
      </section>
    </qx-custom-form>
  </qx-card-form>
</template>

<script>
import ChooseWorker from 'components/choose/worker';
export default {
  props: {
    title: {
      default: '',
    },
    formName: {
      default: '',
    },
  },
  components: {
    ChooseWorker,
  },
  data () {
    return {
      selectedWorkers: '',
      originData: [],
      baseForm: {
        form: [
        ],
        rules: {
        },
      },
    };
  },
  methods: {
    showUserDialog () {
      this.$refs.chooseWorker.show();
    },
    handleUserOrder2Change (data) {
      const userIds = data.map((item) => item.userId);
      const userNames = data.map((item) => item.linkman);
      this.selectedWorkers = userNames.join(',');
      this.$refs.baseForm.setVal('order2', userIds.join(','));
    },
    handleUserOrder4Change (data) {
      const userIds = data.map((item) => item.userId);
      const userNames = data.map((item) => item.linkman);
      this.selectedWorkers = userNames.join(',');
      this.$refs.baseForm.setVal('order4', userIds.join(','));
    },
    async sub () {
      const allFormName = ['orderInput', 'orderModify'];
      const data = await this.cacheData();
      const result = {};
      data[this.formName].forEach((item, index) => {
        Object.keys(item).forEach((key) => {
          result[`${this.formName}_${index + 1}.${key}`] = item[key];
        });
        result[this.formName + '_num'] = data[this.formName].length;
      });

      return result;
    },
    async cacheData () {
      const res = await this.$refs.baseForm.getVal();
      this.originData.forEach((item, index) => {
        item.value = res['order' + String(index + 1)];
      });
      return {
        [this.formName]: this.originData,
      };
    },
    async init (data = {}) {
      this.originData = data[this.formName];
      this.renderForm();
    },
    renderForm () {
      this.baseForm.form = [];
      this.originData.forEach((item, index) => {
        if (item.nameCode === 'WHITE_LIST_IDS') {
          this.selectedWorkers = item.valueStr;
        }
        if (item.valueType === 'inputNumber') {
          this.baseForm.form.push({
            label: item.name,
            value: 'order' + String(index + 1),
            type: item.valueType,
            unit: item.unitName,
            default: item.value,
            remark: item.remark,
            slot: item.isSlot,
            attr: JSON.parse(item.valueTypeAttr),
          });
        } else if (item.valueType === 'radio') {
          this.baseForm.form.push({
            label: item.name,
            value: 'order' + String(index + 1),
            type: item.valueType,
            unit: item.unitName,
            default: Number(item.value),
            remark: item.remark,
            slot: item.isSlot,
            options: JSON.parse(item.valueTypeAttr),
          });
        } else {
          this.baseForm.form.push({
            label: item.name,
            value: 'order' + String(index + 1),
            type: item.valueType,
            unit: item.unitName,
            default: item.value,
            remark: item.remark,
          });
        }
      });
    },
  },
};
</script>

<style scoped lang="scss">
.choose-flex {
  display: flex;
}
</style>
